import { Map } from 'immutable';
import { SET_SECTION } from './actionTypes';

const DEFAULT_STATE = new Map({
  dealType: null,
  realtyType: null
});

export function section (state = DEFAULT_STATE, action) {
  switch (action.type) {
    case SET_SECTION:
      return state.merge(action.payload);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/Dictionaries/reducer.js